//import { useEffect } from "react";

const Loader = () => {
    // useEffect(() => {
    //     document.body.style.overflow = 'hidden';
        
    //     return () => {
    //       document.body.style.overflow = 'auto';
    //     };
    //   }, []);

  return (
    // <div className="loader-container">
    //   <div className="loader"></div>
    // </div>
    <div>Loading...</div>
  );
};

export default Loader;